export const PHYSREF = {
  navPhysicianReferrals: "nav-physician-referrals",
  page: "physician-referrals-page",
  title: "physician-referrals-title",
  banner: "physician-referrals-reference-banner",
  table: "physician-referrals-table",
  loading: "physician-referrals-loading",
  emptyState: "physician-referrals-empty",
  errorState: "physician-referrals-error",
  row: "physician-referrals-row",
};
